export default "__VITE_ASSET__BKW0iu2e__"